import { Pipe, PipeTransform } from '@angular/core';
import { LearningResource } from '../models/learningResource';

@Pipe({
    name: 'learningResourcesSearch',
    pure: false,
    standalone: false
})
export class LearningResourcesSearchPipe implements PipeTransform {
    transform(items: LearningResource[], search: string): any[] {
        if (!items) {
            return items;
        }

        const searchedLearningResources: LearningResource[] = [];

        if(search) {
            searchedLearningResources.push(...items.filter(r => r.Name?.toLowerCase().includes(search.toLowerCase())));
            searchedLearningResources.push(...items.filter(r => r.Keywords?.toLowerCase().includes(search.toLowerCase())));
            return Array.from(new Set(searchedLearningResources));
        }

        return items;
    }
}
